import { EntityManagerFieldInfos } from '@record-it-npm/synchro-client';
import { createConstructionSiteEntityInfo } from 'record-it-time-common/entity/entities/ConstructionSite/createConstructionSiteEntityInfo';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';
import { ConstructionSite } from './constructionSiteTypes';
export const constructionSiteEntityInfo = createConstructionSiteEntityInfo<ConstructionSite>({
  additionalFieldInfos: EntityManagerFieldInfos.createAdditionalFieldInfos<AppSynchronizationEnvironmentTypes>()
});